export function coverFromTitle(title = "") {
  // simple fallback cover using first letter
  const letter = title.trim()[0]?.toUpperCase() || "?";
  return {
    bg: "#1e293b",
    fg: "#fff",
    letter,
  };
}
